export const GET_TRANSACTIONS_REQUEST = "GET_TRANSACTIONS_REQUEST"
export const GET_TRANSACTIONS_REQUEST_SUCCESS = "GET_TRANSACTIONS_REQUEST_SUCCESS"

export const GET_USER_TRANSACTIONS_REQUEST = "GET_USER_TRANSACTIONS_REQUEST"
export const GET_USER_TRANSACTIONS_REQUEST_SUCCESS = "GET_USER_TRANSACTIONS_REQUEST_SUCCESS"

